/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileAttachment } from './FileAttachment';
import {
    FileAttachmentFromJSON,
    FileAttachmentFromJSONTyped,
    FileAttachmentToJSON,
    FileAttachmentToJSONTyped,
} from './FileAttachment';

/**
 * 
 * @export
 * @interface FileAttachmentResponse
 */
export interface FileAttachmentResponse {
    /**
     * List of file attachments
     * @type {Array<FileAttachment>}
     * @memberof FileAttachmentResponse
     */
    files: Array<FileAttachment>;
}

/**
 * Check if a given object implements the FileAttachmentResponse interface.
 */
export function instanceOfFileAttachmentResponse(value: object): value is FileAttachmentResponse {
    if (!('files' in value) || value['files'] === undefined) return false;
    return true;
}

export function FileAttachmentResponseFromJSON(json: any): FileAttachmentResponse {
    return FileAttachmentResponseFromJSONTyped(json, false);
}

export function FileAttachmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileAttachmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'files': ((json['files'] as Array<any>).map(FileAttachmentFromJSON)),
    };
}

export function FileAttachmentResponseToJSON(json: any): FileAttachmentResponse {
    return FileAttachmentResponseToJSONTyped(json, false);
}

export function FileAttachmentResponseToJSONTyped(value?: FileAttachmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'files': ((value['files'] as Array<any>).map(FileAttachmentToJSON)),
    };
}

